/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\invitation.genclient.json
 */

"use strict";

import Contracts = require("VSS/Invitation/Contracts");
import VSS_Service = require("VSS/Service");
import VSS_WebApi = require("VSS/WebApi/RestClient");
import VSS_WebApi_Constants = require("VSS/WebApi/Constants");

export class CommonMethods4_1To7_2 extends VSS_WebApi.VssHttpClient {

    public static serviceInstanceId = VSS_WebApi_Constants.ServiceInstanceTypes.SPS;
    protected invitationsApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * [Preview API] Send invitation to a batch of users Currently only support less than 1000 users
     *
     * @param {Contracts.InvitationData} invitationData - Invitation Data
     * @return IPromise<Contracts.SendInvitationsResponse>
     */
    public sendInvitations(
        invitationData: Contracts.InvitationData
        ): IPromise<Contracts.SendInvitationsResponse> {

        return this._beginRequest<Contracts.SendInvitationsResponse>({
            httpMethod: "POST",
            area: "Invitation",
            locationId: "bc7ca053-e204-435b-a143-6240ba8a93bf",
            resource: "Invitations",
            routeTemplate: "_apis/{resource}/{userId}",
            requestType: Contracts.TypeInfo.InvitationData,
            responseType: Contracts.TypeInfo.SendInvitationsResponse,
            apiVersion: this.invitationsApiVersion,
            data: invitationData
        });
    }

    /**
     * [Preview API] Send Account Invitation to a user
     *
     * @param {Contracts.InvitationData} invitationData - optional Invitation Data
     * @param {string} userId - IdentityId of the user
     * @return IPromise<void>
     */
    public sendInvitation(
        invitationData: Contracts.InvitationData,
        userId: string
        ): IPromise<void> {

        return this._beginRequest<void>({
            httpMethod: "PUT",
            httpResponseType: "html",
            area: "Invitation",
            locationId: "bc7ca053-e204-435b-a143-6240ba8a93bf",
            resource: "Invitations",
            routeTemplate: "_apis/{resource}/{userId}",
            requestType: Contracts.TypeInfo.InvitationData,
            routeValues: {
                userId: userId
            },
            apiVersion: this.invitationsApiVersion,
            data: invitationData
        });
    }
}

/**
 * @exemptedapi
 */
export class InvitationHttpClient7_2 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.invitationsApiVersion = "7.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class InvitationHttpClient7_1 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.invitationsApiVersion = "7.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class InvitationHttpClient7 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.invitationsApiVersion = "7.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class InvitationHttpClient6_1 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.invitationsApiVersion = "6.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class InvitationHttpClient6 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.invitationsApiVersion = "6.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class InvitationHttpClient5_2 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.invitationsApiVersion = "5.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class InvitationHttpClient5_1 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.invitationsApiVersion = "5.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class InvitationHttpClient5 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.invitationsApiVersion = "5.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class InvitationHttpClient4_1 extends CommonMethods4_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.invitationsApiVersion = "4.1-preview.1";
    }
}

export class InvitationHttpClient extends InvitationHttpClient7_2 {
    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }
}

const clientMapping: { [id: string]: new (routeRequestPath: string) => VSS_WebApi.VssHttpClient; } = {
    "7.2": InvitationHttpClient7_2,
    "7.1": InvitationHttpClient7_1,
    "7.0": InvitationHttpClient7,
    "6.1": InvitationHttpClient6_1,
    "6.0": InvitationHttpClient6,
    "5.2": InvitationHttpClient5_2,
    "5.1": InvitationHttpClient5_1,
    "5.0": InvitationHttpClient5,
    "4.1": InvitationHttpClient4_1
}

/**
 * Gets an http client targeting the latest released version of the APIs.
 *
 * @return InvitationHttpClient7_1
 */
export function getClient(options?: VSS_WebApi.IVssHttpClientOptions): InvitationHttpClient7_1 {
    if ((<any>window).VSS && (<any>window).VSS.VssSDKRestVersion && clientMapping[(<any>window).VSS.VssSDKRestVersion]) {
        return VSS_Service.getClient<InvitationHttpClient7_1>(<any>(clientMapping[(<any>window).VSS.VssSDKRestVersion]), undefined, undefined, undefined, options);
    }
    else {
        return VSS_Service.getClient<InvitationHttpClient7_1>(InvitationHttpClient7_1, undefined, undefined, undefined, options);
    }
}
